import PageVideoLanding from './PageVideoLanding';

export default PageVideoLanding;
export * from './PageVideoLanding';
